export * from './slide.model';
export * from './slide-action.model';



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/common/models/index.ts